import { useSetRecoilState } from "recoil";
import { documentViewerRecoilState } from "./documentViewer";

export const useDocumentViewer = () => {
    const setDocumentViewerState = useSetRecoilState(documentViewerRecoilState);
    const onClose = (handler: () => void) => {
        setDocumentViewerState((old) => ({ ...old, onClose: handler }));
    };
    const showAttachments = (attachmentIds: number[]) => {
        setDocumentViewerState((old) => ({ ...old, attachmentIds: attachmentIds }));
    };
    const closeDocumentViewer = () => {
        setDocumentViewerState((old) => ({ ...old, attachmentIds: [] }));
    };

    return { showAttachments, closeDocumentViewer, onClose };
};
